import httpService from "./http.service";

class FormService {
    getUrl = "/forms";

    getForms = () => {
        return httpService.get(this.getUrl);
    };
    createForm = (model) => {
        return httpService.post("/forms", model);
    };
    createGroupForm = (model) => {
        return httpService.post("/forms/create-group", model);
    };
    editForm = (id, model) => {
        return httpService.patch("/forms/" + id, model);
    };
    deleteForm = (id) => {
        return httpService.delete("/forms/" + id);
    };
    getUserAnswers = (formId) => {
        return httpService.get(`/forms/ansOfForms/${formId}`);
    };
}

const formService = new FormService();
export default formService;